import { BuildTime } from '../../../api';

export const getTimeDifferenceMs = (date1: Date, date2: Date): number => {
  return Math.abs(date1.getTime() - date2.getTime());
};

export const calculateBuildTimeDuration = (
  startTime?: BuildTime,
  endTime?: BuildTime,
) => {
  if (!startTime || !endTime) return 'N/A';
  const getMs = (time: BuildTime) => {
    if (!time) return 0;
    if (typeof time === 'string') {
      return new Date(time).getTime();
    }
    return parseInt(time.seconds, 10) * 1000 + parseInt(time.nanos, 10) / 1e6;
  };

  const startMs = getMs(startTime);
  const endMs = getMs(endTime);
  const durationMs = getTimeDifferenceMs(new Date(startMs), new Date(endMs));

  // Format as seconds or minutes:seconds as needed
  if (durationMs < 60000) {
    return `${Math.floor(durationMs / 1000)}s`;
  }
  const minutes = Math.floor(durationMs / 60000);
  const seconds = Math.floor((durationMs % 60000) / 1000);
  return `${minutes}m ${seconds}s`;
};
